import React, { useRef } from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
function WebsiteForm() {
  const recaptcha = useRef();
  const form = useRef();
  const handleSubmit = (event) => {
    event.preventDefault();
    emailjs
      .sendForm(
        "service_ndzv52f", // Replace with your EmailJS Service ID
        "template_zk2pc2q", // Replace with your EmailJS Template ID
        form.current,
        "iIoDh9_uH3NZhc0XU" // Replace with your EmailJS User ID
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Email sent successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send email. Please try again.");
        }
      );
  }
  return (
    <Layout header={1} footer={1} className="" mainClassName="">
      <BreadcrumbArea
        title={"Website Form"}
        subtitle={"Website Form"}
        className={"breadcrumb-area-two pt-175 pb-60"}
        showShape={false}
      />
      <div className="container consultation-form-wrap">
        <form onSubmit={handleSubmit} ref={form}>
          <div className="row">
            <div class="form-group col-sm-6 form-grp">
              <input
                type=""
                class="form-control"
                id="exampleInputEmail1"
                name="name"
                aria-describedby="emailHelp"
                placeholder="Full Name" required
              />
            </div>
            <div class="form-group col-sm-6 form-grp">
              <input
                type=""
                class="form-control"
                name="email"
                id="exampleInputPassword1"
                placeholder="Email" required
              />
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
                Exact name of your business/organization: *
              </label>
            </div>
            <div className="col-sm-6 form-grp">
              <input
                type=""
                class="form-control "
                name="bName"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Your Business Name" required
              />
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              Kindly state the purpose of your website: (Is it a selling/informative website or a personal blog? etc.) *
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" required rows="3" placeholder="Describe Here." name="field2"></textarea>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              As per the navigation of your website, kindly state the title of your WebPages: (E.g.: Company Profile, Contact us etc.) *
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" required rows="3"  placeholder="Describe Here." name="field3"></textarea>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              What type of overall feeling would you like to project with your new Website Domain? (Corporate, fun, high-tech, etc...) Leave this field blank if you would like us to make this determination.
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" required rows="3" placeholder="Describe Here." name="field4"></textarea>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              Please give a brief description of your business: (What type of products or services does your company supply? etc...) *
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" required rows="3" placeholder="Describe Here." name="field5"></textarea>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              State the target audience of your website:
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" required rows="3" placeholder="Describe Here." name="field6"></textarea>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              State the Competitors of your website:
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" required rows="3" placeholder="Describe Here." name="field7"></textarea>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              Do you have any specific design, preferences? If yes, please mention a reference: (If you have any particular likes or dislikes regarding any competitor's website etc.) *
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" required rows="3" placeholder="Describe Here." name="field8"></textarea>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <label for="exampleInputEmail1">
              Do you have any additional comments?
              </label>
            </div>
            <div className="col-sm-6">
            <textarea class="form-control form-grp-text-area" id="exampleFormControlTextarea1" rows="3" required placeholder="Describe Here." name="field9"></textarea>
            </div>
          </div>
          <div className="">
          <h4 className="">Domain and Web Hosting Details</h4>
          <span className="">Please give us a few details about the domain name and hosting of the website.</span>
          </div>
          <div className="d-flex align-items-center gap-4 ">
            <p>Do you have a Domain Name?: *</p>
            <input type="radio" name="d1" id="d1" value={"yes"} />
            <label htmlFor="d1">Yes</label>
            <input type="radio" name="d1" id="d1" value={"no"}/>
            <label htmlFor="d1">No</label>
          </div>
          <div className="d-flex align-items-center gap-4 ">
            <p>Do you want us to provide hosting for your website?: *</p>
            <input type="radio" name="d2" id="d2" value={"yes"}/>
            <label htmlFor="d2">Yes</label>
            <input type="radio" name="d2" id="d2" value={"no"}/>
            <label htmlFor="d2">No</label>
          </div>
          <p><span style={{color: "red"}}>Note </span>: We will send you a "Page under construction" template on your respective domain name, very soon. Meanwhile, our professional designers will be working on your custom website design. It will get uploaded as soon as you approve the final design.</p>
          <ReCAPTCHA
              sitekey={"6LfrdtUqAAAAAFb4hjwtai1FHpMgpU76t_oQNuuK"}
              ref={recaptcha}
            />
          <div className="d-flex justify-content-center">
          <button type="submit" class="btn" style={{margin: "3rem 0rem", width: "15%"}} >
            Submit
          </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
export default WebsiteForm;